import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from 'react-transition-group';
import './Error.css'

const Error = ({text}) => {
  return (
    <CSSTransition
      in={!!text}
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
      <div className='error-wrapper'>
        <FontAwesomeIcon icon={faCircleExclamation}/>
        <div>{text}</div>
      </div>
    </CSSTransition>
  )
}

Error.propTypes = {
  text: PropTypes.string
};

export default Error;